import requests from "./httpService";

const VehicleTypeServices = {
  getAllVehicleType: async (body) => {
    return requests.get(`/vehicletype/`);
  },

  addVehicleType: async (body) => {
    return requests.post(`/vehicletype/add`, body);
  },
  getVehicleTypeById: async (id) => {

    return requests.get(`/vehicletype/${id}`);
  },
  updateVehicleType: async (id, body) => {
    return requests.put(`/vehicletype/update/${id}`, body);
  },

  deleteVehicleType: async (id, body) => {
    return requests.delete(`/vehicletype/delete/${id}`, body);
  },
};

export default VehicleTypeServices;
